import store from 'vue-src/store'
import env from "vue-src/utils/constants"
import cloneDeep from "lodash-es/cloneDeep"

const scroll = require('vue-scrollto')

const noImageProvidedUrl = window.noImageProvidedUrl
const NODE_ENV = env.NODE_ENV
const MEDIA_URL = env.IX_URL

const _stickyScroll = function (element, duration) {
  let is_not_mobile = !(window.innerWidth < 992),
      options = {offset: 0}
  if (is_not_mobile) {
    options.offset = -108
  }
  return scroll.scrollTo(element, duration, options)
}

const _addMsg = function (type, message, element) {
  let payload = {type: type, message: message}
  store.commit('msg/addMsg', payload)
  if (element) {
    return _stickyScroll(element, 500)
  }
  return false
}

export const MESSAGE_TYPES = ['danger', 'info', 'success', 'warning']

let msgFuncs = {}

MESSAGE_TYPES.forEach(t => msgFuncs[t] = (m, e = false) => _addMsg(t, m, e))

export const msg = msgFuncs

export const cleanObj = function (obj) {
  return cloneDeep(obj)
  //return JSON.parse(JSON.stringify(obj))
}


export const debugLog = env.DEBUG_LOG

export const priceStr = function (number) {
  return parseFloat(number)
      .toLocaleString('en-us', {
    style: 'currency',
    currency: 'USD'
  })
}

export const staticUrl = function (file) {
  return window.rootStaticUrl + file
}

export const mediaURL = function(url) {
  const prefix = MEDIA_URL.replace(/\/$/, '')
  return `${prefix}${url}`
}

export const getAttributeValue = function (attributes, key) {
  if (typeof attributes === 'undefined') {
    return null
  }
  let ret = attributes.filter(attribute => attribute.name === key)

  if (ret.length > 0) {
    return ret[0].value
  }
  return null
}

export const findFirstMultimediaAttributeValue = function (listOfMultimedia, type, key, value) {
  return listOfMultimedia.filter(function (item) {
    return getAttributeValue(item[type].attributes, key) === value
  })[0]
}

export const findAllMultimediaAttributeValue = function (listOfMultimedia, type, key, value) {
  return listOfMultimedia.filter(function (item) {
    return getAttributeValue(item[type].attributes, key) === value
  })
}

export const getCartThumbnail = function (product) {
  if (product.product_thumbnail) {
    return product.product_thumbnail
  }
  return noImageProvidedUrl
}

export const catLink = function (slug) {
  let mx = env.MX_LINK ? env.MX_LINK : '/mx/'
  return mx + slug + '/'
}

export const itemLink = function (slug, stock_number = '') {

  let item = env.ITEM_LINK ? env.ITEM_LINK : '/item/'
  let id = slug
  if (!id || id === '') id = stock_number
  return item + id + '/'
}



// WEBPACK FOOTER //
// ./ixcms/themes/src/vue-src/utils/index.js